import { useFormContext } from './form';
import React from 'react';
import { FormInput } from './FormInput';
import { IGS_TYPES } from '../../../constants/vesselRequirements';
import { IconButton } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { FormSelect, Select } from './FormSelect';
import { Field } from './FormField';

const defaultSystem = { type: '', capacity: '', percentage: '' };
export function FormIGS() {
    const form = useFormContext();
    const { igs = {} } = form.values;
    const { fitted } = igs;
    let { systems } = igs;
    if (!systems || !systems.length) {
        systems = [defaultSystem];
    }

    const addRow = () => form.onChange({
        field: 'igs',
        value: { fitted, systems: [...systems, defaultSystem] },
    });

    const removeRow = index => form.onChange({
        field: 'igs',
        value: { fitted, systems: systems.filter((_, i) => i !== index) },
    });

    const change = (index, key, value) => form.onChange({
        field: 'igs',
        value: {
            fitted,
            systems: systems.map((system, i) =>
                (i === index ? {
                    ...system,
                    [key]: value,
                } : system)),
        },
    });

    return (
        <React.Fragment>
            {systems.map((system, index) => (
                <div className='row' key={index}>
                    <div className='col-xs-3'>
                        {index === 0 && (
                            <Select
                                name='igs.fitted'
                                value={fitted}
                                label='IGS'
                                onChange={({ value }) => form.onChange({
                                    field: 'igs',
                                    value: { fitted: value, systems },
                                })}
                                options={[
                                    { value: null, label: undefined },
                                    { value: true, label: 'Yes' },
                                    { value: false, label: 'No' },
                                ]}
                            />
                        )}
                    </div>
                    <div className='col-xs-3'>
                        <Select
                            name='type'
                            label='IGS type'
                            value={system.type}
                            onChange={({ field, value }) => {
                                change(index, field, value);
                            }}
                            disabled={!fitted}
                            options={['', ...IGS_TYPES]}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Field
                            value={system.capacity}
                            label='Capacity, cbm/hr'
                            disabled={!fitted}
                            floatNumber
                            onChange={(_, value) => {
                                change(index, 'capacity', value);
                            }}
                        />
                    </div>
                    <div className='col-xs-2'>
                        <Field
                            value={system.percentage}
                            label='%'
                            disabled={!fitted}
                            floatNumber
                            onChange={(_, value) => {
                                change(index, 'percentage', value);
                            }}
                        />
                    </div>
                    <div className='col-xs-1'>
                        <div style={{ margin: '25px 0 0 0' }}>
                            {index === 0 && (
                                <IconButton
                                    disabled={!fitted}
                                    onClick={addRow}
                                >
                                    <ContentAddIcon color='green' />
                                </IconButton>
                            )}
                            {index !== 0 && (
                                <IconButton
                                    disabled={!fitted}
                                    onClick={() => removeRow(index)}
                                >
                                    <ContentRemoveIcon color='red' />
                                </IconButton>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormIGS.jsx